module.exports = "<app-main-banner></app-main-banner>\n<app-portfolio-preview></app-portfolio-preview>\n<app-testimonials></app-testimonials>\n<app-events></app-events>\n<div id=\"contacts\"></div>\n<app-message-form></app-message-form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home.component.html
// module id = ./src/app/pages/home/home.component.html
// module chunks = main